import axiosInstance from "./axiosInstance";
import { API_KEY, USER_ID } from "./settings";

export const getUserAsync = async () => {
  const url = `Usuario/GetById/${USER_ID}/${API_KEY}/${USER_ID}`;
  const axios = axiosInstance();
  const res = await axios.get(url);
  return res.data;
};
